import React, { forwardRef } from "react";
import styled, { css } from "styled-components";

interface IStyledProps {
  variant?: "light" | "secondary";
}

interface IProps {
  icon: React.ReactNode;
  isBack?: boolean;
  label: string;
  onClick?: () => void;
}

type Props = IStyledProps & IProps;

const StyledBoldLinkButton = styled.button<IStyledProps>`
  display: inline-flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 1.5rem ${(props) => props.theme.space[3]};
  border: 0;
  border-radius: 3px;
  background-color: ${(props) => props.theme.colors.yellowLight};
  box-shadow: inset 0 0 0 2px ${({ theme }) => theme.colors.yellow};
  color: ${(props) => props.theme.colors.offBlack};
  font-size: ${({ theme }) => theme.fontSizes[1]};
  font-weight: 500;
  text-decoration: none;
  cursor: pointer;

  ${(props) =>
    props.variant === "secondary" &&
    css`
      background-color: ${(props) => props.theme.colors.secondary};
      box-shadow: inset 0 0 0 2px ${({ theme }) => theme.colors.secondary};
      color: ${(props) => props.theme.colors.white};
    `}

  &:hover {
    text-decoration: none;
  }

  svg {
    fill: currentColor;
  }
`;

const BoldLinkButton = forwardRef<HTMLButtonElement, Props>(
  ({ icon, isBack = false, label, ...rest }, ref) => (
    <StyledBoldLinkButton ref={ref} {...rest}>
      {isBack ? (
        <>
          <span>{icon}</span>
          <span>{label}</span>
        </>
      ) : (
        <>
          <span>{label}</span>
          <span>{icon}</span>
        </>
      )}
    </StyledBoldLinkButton>
  ),
);

export default BoldLinkButton;
